import GoogleMaterialIcon from '@/components/icons/google-material-icon/google-material-icon';
import { taxonomyAPI } from '@/providers/apis/taxonomy/taxonomy';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
    name: 'default-groups',
    components: {
        'material-icons': GoogleMaterialIcon,
    },
})

export default class DefaultGroups extends Vue {

    // --------------------------------------------------------------------
    // Properties

    @Prop({ default: null })
    private value: any;

    @Prop({ default: false })
    private isReadOnly!: boolean;

    @Prop({ default: 'value' })
    private valueFields!: string;

    @Prop({ default: 'text' })
    private textFields!: string;

    private groupsData = {} as { country: number, state: number };

    private countries: any = [];

    private states: any = [];

    private selectedName: any = {};

    // ---------------------------------------------------------------------
    // Hooks

    private created() {
        this.groupsData = this.value || {};
        this.loadData();

    }

    // ---------------------------------------------------------------------
    // Hooks

    private onSelectCountry(countryId: number) {
        this.fetchStates(countryId);
    }

    // ---------------------------------------------------------------------
    // Methods

    private loadData() {
        const groupData = this.groupsData;
        this.fetchCountries();
        if (groupData && groupData.country) {
            this.fetchStates(groupData.country);
        }
    }

    private fetchCountries() {
        taxonomyAPI.fetchTaxonomyCountry().then((countries: any) => {
            this.countries = countries.groups;
            if (this.groupsData && this.groupsData.country) {
                const selectedCountry = this.countries.find((item: any) => {
                    return item.id === this.groupsData.country;
                });
                this.$set(this.selectedName, 'country', selectedCountry.name);
            }
        });
    }

    private fetchStates(countryId: number) {
        const params = {
            id: countryId,
        };
        taxonomyAPI.fetchTaxonomyState(params).then((states: any) => {
            this.states = states.groups;
            if (this.groupsData && this.groupsData.state) {
                const selectedState = this.states.find((item: any) => {
                    return item.id === this.groupsData.state;
                });
                this.$set(this.selectedName, 'state', selectedState.name);
            }
        });
    }

    private showMore() {
        this.$emit('showMore');
    }

    private adjustHeight() {
        this.$emit('showMore');
    }

    private onUpdateCountry() {
        this.fetchStates(this.groupsData.country);
        this.groupsData.state = NaN;
        this.updateData();
    }

    private onUpdateState() {
        this.updateData();
    }

    private updateData() {
        this.$emit('input', this.groupsData);
    }
}
